import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

type GridSize =
  | number
  | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };

interface WidgetSkeletonProps {
  length?: number;
  size?: GridSize;
}

export default function WidgetSkeleton({
  length = 4,
  size = 3,
}: WidgetSkeletonProps) {
  return (
    <>
      {Array.from({ length }).map((_, index) => (
        <Grid key={index} size={size}>
          <Paper
            sx={{
              p: 2,
              borderRadius: "12px",
              height: 120,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Skeleton variant="text" width="60%" height={28} animation="wave" />
            <Skeleton variant="text" width="40%" height={36} animation="wave" />
            <Skeleton
              variant="circular"
              width={40}
              height={40}
              animation="wave"
              sx={{ alignSelf: "flex-end" }}
            />
          </Paper>
        </Grid>
      ))}
    </>
  );
}
